import fr from './langs/fr';
import en from './langs/en';
import srn from './langs/srn';
import ptBR from './langs/pt-BR';
import pt from './langs/pt';
import es from './langs/es';
import nl from './langs/nl';
import gcr from './langs/gcr';
import ht from './langs/ht';
import ru from './langs/ru';
import ar from './langs/ar';
import arSY from './langs/ar-SY';
import zh from './langs/zh';
import de from './langs/de';
import it from './langs/it';
import ro from './langs/ro';
import pl from './langs/pl';
import tr from './langs/tr';

const translations = {
  fr,
  en,
  srn,
  'pt-BR': ptBR,
  pt,
  es,
  nl,
  gcr,
  ht,
  ru,
  ar,
  'ar-SY': arSY,
  zh,
  'zh-CN': zh, // alias — 'zh' est déjà le chinois simplifié complet (décision Carlos 2026-09-12)
  de,
  it,
  ro,
  pl,
  tr,
};

// Language order: Guyane prioritized first, then International
export const languageOrder = [
  'fr', 'gcr', 'ht', 'pt-BR', 'pt', 'es', 'en', 'srn', 'nl', 'de', 'it', 'ro', 'pl', 'tr', 'ru', 'ar', 'ar-SY', 'zh'
];

export default translations;
